import React from 'react';
import { Select, theme, RadioGroup, Radio, Space } from 'components';
import styled from 'styled-components';
import { PopulatedUser } from 'api/UserController/getProfile';
import ShackleAssigneeSearchBar from './ShackleAssigneeSearchBar';
import { LockboxPermissionType, ShackleSetting } from './types';

type LockboxDisplayWithShackleProps = {
  visible?: boolean;
  user?: PopulatedUser;
  permission: LockboxPermissionType | undefined;
  shackleSetting: ShackleSetting;
  shackleUserIds: string[] | undefined;
  onPermissionChange: (
    lockboxId: string,
    permissionType: LockboxPermissionType,
  ) => void;
  onShackleSettingChange: (setting: ShackleSetting) => void;
  onShackleUserIdsChange: (userIds: string[] | undefined) => void;
};

const AddLockboxModalWithShackleDisplay: React.FC<
  LockboxDisplayWithShackleProps
> = ({
  visible,
  user,
  permission,
  shackleSetting,
  shackleUserIds,
  onPermissionChange,
  onShackleSettingChange,
  onShackleUserIdsChange,
}) => {
  if (visible) {
    return (
      <>
        <StyledFlexContainer>
          <StyledColumnHeader>Permissions</StyledColumnHeader>
          <StyledColumnHeader>Add Shackle Permissions</StyledColumnHeader>
        </StyledFlexContainer>
        <StyledDivider />
        <StyledFlexContainer>
          <StyledColumnHeader>
            <StyledSelectPermission
              bordered={false}
              placeholder="Select Permissions"
              onChange={value => onPermissionChange('', value)}
              options={[
                { key: 1, value: 'owner', label: 'Owner' },
                { key: 2, value: 'assignee', label: 'Assignee' },
              ]}
            />
          </StyledColumnHeader>
          <StyledColumnHeader>
            <RadioGroup
              value={shackleSetting}
              onChange={({ target: { value } }) => {
                onShackleSettingChange(value);
              }}
            >
              <Space direction="vertical" size="small">
                <Radio value={'none'} data-cy="rb-none">
                  None
                </Radio>
                <Radio value={'everyone'} data-cy="rb-everyone">
                  Everyone in Office
                </Radio>
                <Radio value={'individual'} data-cy="rb-individual">
                  Specific Individuals
                </Radio>
              </Space>
            </RadioGroup>
            <ShackleAssigneeSearchBar
              visible={shackleSetting === ShackleSetting.Individual}
              user={user}
              isCrossOrgSearch={permission === 'owner'}
              shackleUserIds={shackleUserIds}
              onShackleUserIdsChange={onShackleUserIdsChange}
            />
          </StyledColumnHeader>
        </StyledFlexContainer>
        <StyledDivider />
      </>
    );
  }

  return null;
};

const StyledSelectPermission = styled(Select)`
  margin-left: -12px;
  width: 75%;
  .ant-select-selection-item {
    color: ${theme.blue6};
  }
  .ant-select-selection-placeholder {
    color: ${theme.blue6};
  }
  .anticon-down {
    color: ${theme.blue6};
  }
`;

const StyledFlexContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  align-items: start;
`;

const StyledColumnHeader = styled.div`
  float: left;
  width: 50%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: grey;
`;

const StyledDivider = styled.div`
  height: 1px;
  width: 100%;
  border: 1px solid #ededed;
`;

export default AddLockboxModalWithShackleDisplay;
